// One view per user and video: the server refuses a second one.
export const VIEW_VIDEO = `
  mutation viewVideo($id: ID!) {
    viewVideo(id: $id)
  }
`;

// Admin: the user starts over, his "Pour toi" shows the seen videos again. Returns the views deleted.
export const ADMIN_DELETE_USER_VIEWS = `
  mutation adminDeleteUserViews($userId: ID!) {
    adminDeleteUserViews(userId: $userId)
  }
`;
